import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconStoreReseller from '@/icons/StoreReseller.svg';

export const StoreResellerBadge = ({ size = 'small' }: { size?: 'small' | 'large' }) => (
  <Badge color="secondary" size={size} hasBorder>
    <IconStoreReseller />
    <Trans id="request.header.store.distributor">Distributor</Trans>
  </Badge>
);
